import { action, computed, makeObservable, observable } from 'mobx';
import { CardData, IRecordCardController } from './types';

export class Card implements IRecordCardController {
  @observable private _data?: CardData = undefined;

  constructor(initialData?: CardData) {
    this._data = initialData;

    makeObservable(this);
  }

  @computed get data() {
    return this._data ? { ...this._data } : undefined;
  }

  @action setCard = (data: CardData) => {
    if (this._data && Card.isCardDataEqual(this._data, data)) return;

    this._data = data;
  };

  @action deleteCard = () => {
    if (!this.data) return;

    this._data = undefined;
  };

  static isCardDataEqual(d1: CardData, d2: CardData) {
    return (
      d1.tableName === d2.tableName &&
      d1.recordId === d2.recordId &&
      d1.layerName === d2.layerName
    );
  }
}
